export const getRealStringLength = str => {
  let len = 0
  Array.from(str).forEach(s => {
    const charCode = s.charCodeAt(0)
    len += charCode >= 0 && charCode <= 128 ? 1 : 2
  })
  return len
}

export const subString = (str, length) => {
  const r = /[^\x00-\xff]/g
  let m

  if (str.replace(r, '**').length > length) {
    m = Math.floor(length / 2)

    const fullLength = str.length
    for (let i = m; i < fullLength; i += 1) {
      if (str.substr(0, i).replace(r, '**').length >= length) {
        return str.substr(0, i)
      }
    }
  }

  return str
}



// WEBPACK FOOTER //
// ./src/utils/string.js